import { ChevronDownIcon } from '@100mslive/react-icons';
import {
    Accordion, AccordionActions, AccordionDetails, AccordionSummary, Box, Button,
    List, ListItem, ListItemText, ListItemSecondaryAction,
    FormControl, FormControlLabel, FormLabel, ListItemAvatar, Radio, RadioGroup, TextField
} from '@material-ui/core';
import { Delete, ExpandLess, ExpandMore, UnfoldMore } from '@material-ui/icons';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IsNullOrEmpty } from '../../../helpers/utility.js';
import { fetchCalendarsSuccess } from '../../../store/user/user.actions.js';
import { getCalendars } from '../../../store/user/user.selector.js';
import calendlyLogo from "../../../assets/images/calendly.svg"

export const MeetingControl = ({ onUpdate, value, onDelete, isSelected }) => {
    const dispatch = useDispatch();
    const [label, setLabel] = useState("");
    const [subTitle, setSubTitle] = useState("");
    const [meetingUrl, setMeetingUrl] = useState("");
    const [expanded, setExpanded] = useState(false);
    const access_token = localStorage.getItem("x-calendly-accessToken");

    const { calendars } = useSelector((state) => {
        return {
            calendars: getCalendars(state)
        }
    })

    useEffect(() => {
        try {
            let val = JSON.parse(value);
            setLabel(val.label);
            setSubTitle(val.subTitle);
            setMeetingUrl(val.meetingUrl);
        }
        catch {

        }
    }, [value]);

    useEffect(() => {
        setExpanded(isSelected);
    }, [isSelected])

    useEffect(() => {
        if (access_token) {
            let options = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + access_token }
            };

            fetch('https://api.calendly.com/users/me', options)
                .then(response => response.json())
                .then(response => {
                    console.log(response);
                    fetch('https://api.calendly.com/event_types?organization=' + response.resource.current_organization, options)
                        .then(response => response.json())
                        .then(response => {
                            console.log(response);
                            dispatch(fetchCalendarsSuccess(response));
                        })
                        .catch(err => console.error(err));
                })
                .catch(err => console.error(err));
        }
    }, [access_token])

    return (
        <div className='w-full'>
            <Accordion variant='outlined' expanded={expanded}>
                <AccordionSummary
                    className='handle'
                    expandIcon={
                        expanded ?
                            <ExpandLess onClick={() => setExpanded(!expanded)} /> :
                            <ExpandMore onClick={() => setExpanded(!expanded)} />
                    }
                    aria-label="Expand"
                    aria-controls="additional-actions1-content"
                    id="additional-actions1-header"
                    style={{ padding: "0 5px" }}
                >

                    <Box display="flex" alignItems="center" width={"100%"}>
                        <Box display="flex" alignItems="center">
                            <UnfoldMore htmlColor='#CECECE' />&nbsp;

                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.5 7.11133V3.11133M16.5 7.11133V3.11133M7.5 11.1113H17.5M5.5 21.1113H19.5C20.6046 21.1113 21.5 20.2159 21.5 19.1113V7.11133C21.5 6.00676 20.6046 5.11133 19.5 5.11133H5.5C4.39543 5.11133 3.5 6.00676 3.5 7.11133V19.1113C3.5 20.2159 4.39543 21.1113 5.5 21.1113Z" stroke="#CECECE" stroke-width="1.26316" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </Box>
                        <div className='pl-2 text-gray-500'>
                            Calendar
                        </div>
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <div className='w-full'>
                        <TextField
                            placeholder='Label'
                            label="Label"
                            onChange={(e) => {
                                setLabel(e.target.value);
                                onUpdate(
                                    JSON.stringify({
                                        label: e.target.value,
                                        subTitle: subTitle,
                                        meetingUrl: meetingUrl
                                    }));
                            }}
                            variant='outlined'
                            fullWidth
                            className='my-2'
                            margin="dense"
                            value={label}
                        />
                        <TextField
                            placeholder='Title'
                            label='Title'
                            onChange={(e) => {
                                setSubTitle(e.target.value);
                                onUpdate(
                                    JSON.stringify({
                                        label: label,
                                        subTitle: e.target.value,
                                        meetingUrl: meetingUrl
                                    }));
                            }}
                            variant='outlined'
                            type={"email"}
                            fullWidth
                            margin="dense"
                            className='my-2 mb-4'
                            value={subTitle}
                        />
                        {
                            !IsNullOrEmpty(access_token) && calendars.length > 0 ?
                                <>
                                    <FormControl className='mt-4' component="fieldset">
                                        <FormLabel component="legend">Select Meeting</FormLabel>
                                        <RadioGroup aria-label="gender" name="gender1" value={meetingUrl}
                                            onChange={(e) => {
                                                setMeetingUrl(e.target.value);
                                                onUpdate(
                                                    JSON.stringify({
                                                        label: label,
                                                        subTitle: subTitle,
                                                        meetingUrl: e.target.value
                                                    }));
                                            }}>
                                            {
                                                calendars.map((x) => {
                                                    return <FormControlLabel value={x.scheduling_url} control={<Radio />} label={x.name} />
                                                })
                                            }

                                        </RadioGroup>
                                    </FormControl>
                                    <Button
                                        className="ml-0"
                                        onClick={() => {
                                            localStorage.removeItem("x-calendly-accessToken");
                                            localStorage.removeItem("x-calendly-code");
                                            dispatch(fetchCalendarsSuccess([]));
                                        }}
                                        fullWidth
                                        variant='contained'
                                        color={"secondary"}>
                                        Disconnect Calendly
                                    </Button>
                                </>
                                :
                                <List disablePadding className="border border-color-[#CECECE] p-1 rounded-lg"

                                    onClick={() => {
                                        let url = "https://auth.calendly.com/oauth/authorize?client_id=VHAhbow5w1nyh87cpIZk10TKh0jCEWxo24HOUcHQAec&response_type=code&redirect_uri=https://app.ulalive.com/calendly/auth";
                                        const newwindow = window.open(url, "calendly", 'height=500,width=500');
                                        if (newwindow.focus) { newwindow.focus() }
                                    }}>
                                    <ListItem disableGutters>
                                        <ListItemText className='px-2' primary={<img src={calendlyLogo} />}
                                        />
                                    </ListItem>
                                </List>
                        }

                        {/* <br />
                        <p className='text-center'>Or</p> */}
                        {/* <TextField
                            placeholder='Enter Calendly Meeting Link'
                            onChange={(e) => {
                                setMeetingUrl(e.target.value);
                                onUpdate(
                                    JSON.stringify({
                                        label: label,
                                        subTitle: subTitle,
                                        meetingUrl: e.target.value
                                    }));
                            }}
                            variant='outlined'
                            label="Calendly Meeting Link"
                            type={"meetingUrl"}
                            fullWidth
                            margin="dense"
                            className='my-2'
                            value={meetingUrl}
                        /> */}
                    </div>
                </AccordionDetails>
                <AccordionActions>
                    <Button
                        className="ml-0"
                        startIcon={<Delete />}
                        onClick={() => {
                            setExpanded(false);
                            setLabel("");
                            setSubTitle("");
                            setMeetingUrl("");
                            onDelete();
                        }} fullWidth
                        variant='contained' color="default">
                        Remove
                    </Button>
                </AccordionActions>
            </Accordion>
        </div>
    )
}
